export default "__VITE_ASSET__CPjRGI_k__"